<div class="auth-wrapper auth-v2" style="background-color: #fff">
    <div class="auth-inner row m-0" style="background-color: #fff">
      <!-- Brand logo -->
      <div class="d-none d-lg-flex col-lg-8 align-items-center">
        <div class="w-100 d-lg-flex align-items-center justify-content-center">
          <img
            class="img-logo"
            src="assets/images/pages/cocolab2.png"
            alt="Login V2"
          />
        </div>
      </div>
      <!-- /Left Text-->
      <!-- Login-->
      <div class="d-flex col-lg-4 auth-bg  px-2 p-lg-1">
  
        <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
          <div style="align-content: center; text-align: center;">
            <a href="javascript:void(0);" >
              <img
                src="assets/images/pages/cocolab-logo.png"
                alt="brand-logo"
                height="250"
              />
              
            </a>
          </div>
          <br>
  
          <hr>
  
  

          <br>
          <h2 class="text-center" >
            Iniciar sesión <br>
             (Proveedor)
          </h2>
  
  
          <form
          class="auth-login-form mt-2"
          [formGroup]="loginForm"
          (ngSubmit)="onSubmit()"
        >
          <div class="form-group">
            <label for="login-email" class="form-label"
              >Correo electrónico</label
            >
            <input
              type="email"
              name="username"
              formControlName="username"
              class="form-control"
              placeholder="Email"
              aria-describedby="login-email"
              tabindex="1"
              autofocus
              [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
            />
            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
              <div *ngIf="f.username.errors.required">
                Correo electrónico es requerido
              </div>
              <div *ngIf="f.username.errors.email">
                Debe ser un Correo electrónico válido
              </div>
            </div>
          </div>
  
          <div class="form-group">
            <div class="d-flex justify-content-between">
              <label for="login-password">Contraseña</label>
              <a routerLink="forgot-password">
                <small>¿Olvido de contraseña?</small>
              </a>
            </div>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="passwordTextType ? 'text' : 'password'"
                formControlName="password"
                class="form-control form-control-merge"
                tabindex="2"
                placeholder="Contraseña"
                aria-describedby="login-password"
                [ngClass]="{
                  'is-invalid error': submitted && f.password.errors
                }"
              />
  
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"
                  ><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                    (click)="togglePasswordTextType()"
                  ></i
                ></span>
              </div>
            </div>
            <div
              *ngIf="submitted && f.password.errors"
              class="invalid-feedback"
              [ngClass]="{ 'd-block': submitted && f.password.errors }"
            >
              <div *ngIf="f.password.errors.required">
                Contraseña es requerida
              </div>
            </div>
          </div>
          
          <br />
          <button class="btn btn-primary btn-block" tabindex="4" rippleEffect >
            Iniciar sesión
          </button>
        </form>
  
        <p  class="text-center mt-2">
          <span>¿No estás registrado? </span>
          <a (click)="registerRouter()">
            <span  style="color: #3ab5fd ;">Registrarse</span>
          </a>
        </p>   
        
     
        <p  class="text-center mt-2">
          <a (click)="loginRouter()">
            <span  style="color: #3ab5fd ;">Volver a Inicio sesión</span>
          </a>
        </p>   
        
        </div>
      </div>
      <!-- /Login-->
    </div>
  </div>